(function () {
  national();
  initAccordionTabs(".collapsible-tab.TT20250620");
  setupToggleDescription();
  startCountdown('.countdown_box[data-countdown]');
})();
/**
 * 倒计时函数
 */
function startCountdown(selector) {
  function pad(num) {
    return num.toString().padStart(2, '0');
  }

  const boxes = document.querySelectorAll(selector);
  if (!boxes.length) return;

  boxes.forEach(box => {
    const endTimeStr = box.getAttribute('data-countdown');
    if (!endTimeStr) return;

    const endTime = new Date(endTimeStr.replace(/-/g, '/')); // Safari 兼容
    const now = new Date();

    // ✅ 初始化时先判断：已经结束，直接隐藏
    if (endTime <= now) {
      box.style.display = 'none';
      return;
    }

    function updateCountdown() {
      const now = new Date();
      const diff = endTime - now;

      // ✅ 倒计时过程中结束
      if (diff <= 0) {
        box.style.display = 'none';
        clearInterval(timer);
        return;
      }

      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);

      box.querySelector('.cd-days').textContent = pad(days);
      box.querySelector('.cd-hours').textContent = pad(hours);
      box.querySelector('.cd-minutes').textContent = pad(minutes);
      box.querySelector('.cd-seconds').textContent = pad(seconds);
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
  });
}
/**
 * 国旗功能函数
 */
function national() {
  var contry_USAandGE = document.querySelector(".contry_USAandGE");
  var contry_box = document.querySelector(".contry_box");
  var contry_USAandGEList = document.querySelector(".contry_USAandGEList");
  contry_USAandGE.addEventListener("mouseenter", function () {
    contry_USAandGEList.style.display = "block";
  });
  contry_box.addEventListener("mouseleave", function () {
    contry_USAandGEList.style.display = "none";
  });
}
/**
 * 产品页面collapsible-tab只展开一个功能函数
 */
function initAccordionTabs(selector) {
  const tabs = document.querySelectorAll(selector);
  tabs.forEach((tab) => {
    tab.addEventListener("toggle", function () {
      if (tab.open) {
        tabs.forEach((otherTab) => {
          if (otherTab !== tab && otherTab.open) {
            otherTab.removeAttribute("open");
          }
        });
      }
    });
  });
}
/**
 * 展开收起功能函数
 */
function setupToggleDescription(collapsedClass = 'collapsed') {
  const boxes = document.querySelectorAll('.Copywriting0410');
  const buttons = document.querySelectorAll('.toggle-button');
  boxes.forEach((box, index) => {
    const button = buttons[index];
    if (!box || !button) return;
    button.addEventListener('click', function () {
      box.classList.toggle(collapsedClass);
      button.textContent = box.classList.contains(collapsedClass)
        ? 'Read more +'
        : 'Read less -';
    });
  });
}
/**
 * 展开收起功能函数
 */
(function () {
  function toInt(v, fallback) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function clamp(n, min, max) {
    if (typeof max === "number") return Math.min(Math.max(n, min), max);
    return Math.max(n, min);
  }

  function getInput(root) {
    return root && root.querySelector ? root.querySelector("[data-quantity-input]") : null;
  }

  function getStep(input) {
    // 你 Liquid 里写死 data-increment-value="1" 的话，这里就是 1
    const stepAttr = input.getAttribute("data-increment-value") || input.getAttribute("step");
    const step = toInt(stepAttr, 1);
    return step > 0 ? step : 1;
  }

  function updateButtons(root, input) {
    const minusWrap = root.querySelector("[data-button-wrapper-minus]");
    const plusWrap = root.querySelector("[data-button-wrapper-plus]");

    const min = toInt(input.getAttribute("min"), 1);
    const maxAttr = input.getAttribute("max");
    const max = maxAttr !== null && maxAttr !== "" ? toInt(maxAttr, null) : null;

    const value = toInt(input.value, min);

    if (minusWrap) {
      const disabled = value <= min;
      minusWrap.classList.toggle("quantity-selector__button-wrapper--disabled", disabled);
      const btn = minusWrap.querySelector("button");
      if (btn) btn.disabled = disabled;
    }

    if (plusWrap) {
      const disabled = typeof max === "number" ? value >= max : false;
      plusWrap.classList.toggle("quantity-selector__button-wrapper--disabled", disabled);
      const btn = plusWrap.querySelector("button");
      if (btn) btn.disabled = disabled;
    }
  }

  function applyDelta(root, delta) {
    const input = getInput(root);
    if (!input) return;

    const min = toInt(input.getAttribute("min"), 1);
    const maxAttr = input.getAttribute("max");
    const max = maxAttr !== null && maxAttr !== "" ? toInt(maxAttr, null) : null;

    const step = getStep(input);
    const current = toInt(input.value, min);
    const next = clamp(current + delta * step, min, max);

    input.value = String(next);

    // 让 Shopify/主题监听到变化（购物车更新常靠 change）
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    updateButtons(root, input);
  }

  // 初始化一次：刷新禁用状态
  function initAll() {
    document.querySelectorAll("[data-quantity-selector]").forEach((root) => {
      const input = getInput(root);
      if (input) updateButtons(root, input);
    });
  }

  // 关键：捕获阶段拦截点击，阻止主题自带逻辑
  document.addEventListener(
    "click",
    (e) => {
      const plus = e.target.closest("[data-quantity-plus]");
      const minus = e.target.closest("[data-quantity-minus]");
      if (!plus && !minus) return;

      const root = e.target.closest("[data-quantity-selector]");
      if (!root) return;

      // 阻止主题脚本继续处理这次点击
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (plus) applyDelta(root, +1);
      else applyDelta(root, -1);
    },
    true // capture = true，确保比主题的冒泡监听更早拿到事件
  );

  // 输入框手动改值时也同步按钮状态
  document.addEventListener(
    "input",
    (e) => {
      const input = e.target && e.target.matches && e.target.matches("[data-quantity-input]") ? e.target : null;
      if (!input) return;
      const root = input.closest("[data-quantity-selector]");
      if (!root) return;
      updateButtons(root, input);
    },
    true
  );

  // 首次加载初始化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
/**
 * 电话功能
 */
const box = document.getElementById('box1');
const popupBox = document.getElementById('popupBox12');
const closeBtn12 = document.getElementById('closeBtn12');
box.addEventListener('click', function() {
  popupBox.style.display = 'block';
});
closeBtn12.addEventListener('click', function() {
  popupBox.style.display = 'none';
});

